import moment from "moment";
import React from "react";
import FormFooter from "../FormFooter/FormFooter";
import { useSelector } from "react-redux";
import Images from "../../assets";
import numberToWords from "number-to-words";

const LDRollOver = () => {
  const retrievedData = useSelector((state) => state?.formdata);
  console.log("retrive data", retrievedData);

  let invoiceamt = retrievedData?.bgAmtAndInterestAmt || 0;

  let invoicewords = numberToWords.toWords(invoiceamt);

  let samebgm3value = retrievedData?.rolloverSameBgM3Value || 0;

  let samebgwords = numberToWords.toWords(samebgm3value);
  let newbgm1m2value =
    Number(retrievedData?.rolloverNewBgM1Value || 0) +
    Number(retrievedData?.rolloverNewBgM2Value || 0);

  let newbgm1m2words = numberToWords.toWords(newbgm1m2value);
  const data = [
    {
      sno: 1,
      dueDate: "12.11.2024",
      bankDeductingDate: "12.11.2024",
      bgNumber: "0042BG000252024",
      bgUSD: "17,352.58",
      forwardUSD: "17,352.58",
      forwardCoveredFromDate: "12.11.2024 TO 12.11.2024",
    },
  ];
  return (
    <>
      <div className="px-4 my-4">
        <div className="d-flex flex-column py-2">
          <h6 className="text-center fw-bold">
            MEMORANDUM OF CHARGE/LIEN OVER DEPOSITS WHERE DEPOSIT IS COLLATERAL
          </h6>
          <div className="d-flex justify-content-between py-2">
            {/* LEFT SIDE - FROM */}
            <div className="d-flex flex-column">
              <p className="status-waiver-content">From,</p>
              <p className="status-waiver-content">BEST TIMBERS</p>
              <p className="status-waiver-content">NEW NO:515, OLD NO:274,</p>
              <p className="status-waiver-content">SYDENHAMS RD,</p>
              <p className="status-waiver-content">NEHRU TIMBER MARKET</p>
              <p className="status-waiver-content">Chennai - 600112</p>
            </div>

            {/* RIGHT SIDE - TO */}
            <div className="d-flex flex-column text-end">
              <p className="status-waiver-content">To,</p>
              <p className="status-waiver-content">
                THE SOUTH INDIAN BANK LIMITED
              </p>
              <p className="status-waiver-content">Branch: Kellys</p>
            </div>
          </div>

          {/* LETTER DETAILS */}
          <div className="d-flex justify-content-between py-2">
            <p className="status-waiver-content">Letter No.</p>
            <p className="status-waiver-content">
              Date : {moment().format("DD.MM.YYYY")}
            </p>
          </div>

          <div className="d-flex flex-column  py-2">
            <p className="status-waiver-content">Sir/Madam</p>
            <p className="status-waiver-content">
              Sub:WHEREAS at my/our request Bank has granted/agreed to extend a
              loan/limit/facility by way of SBLC facility in the account of BEST
              TIMBERS against the security of schedule mentioned deposit/s of
              Rs&nbsp;
              {retrievedData?.rolloverType == "sameBg"
                ? { samebgm3value }
                : newbgm1m2value}
              /-(Rupees{" "}
              {retrievedData?.rolloverType == "sameBg"
                ? samebgwords
                : newbgm1m2words}{" "}
              Only ) in my/our name(s).
            </p>
          </div>

          <p className="status-waiver-content  py-2">
            1) Now in consideration of Bank having extended/agreed to extend a
            loan/limit/facility by way of SBLC facility of USD {invoiceamt} /-
            (USD
            {invoicewords} only ) in the account of BEST TIMBERS. I/WE hereby
            create Lien/charge over the schedule mentioned deposit/s, as
            security for the due repayment of amount due under the above said
            loan/limit/facility. I/WE hereby hand over the Deposit receipt/s in
            respect of the Schedule as mentioned deposit/s, duly discharged by
            me/ us to be held by the bank as security for the respect of the
            above loan/limit/facility. The lien/Charge created by me/us over the
            Schedule mentioned deposit/s shall operate as a continuing security
            for the loan availed and that may be availed in future.
          </p>
          <p className="status-waiver-content  py-2">
            2) I/We hereby agree that the Bank has got the full power and
            authority to demand repayment of the entire loan amount with
            interest, at its own discretion, prior to the due date fixed for
            repayment.
          </p>
          <p className="status-waiver-content  py-2">
            3) I/WE hereby agree that in the event of premature closure of
            deposit/s for set off towards the amount due to the Bank, the
            interest rate applicable for the period up to the date of premature
            closure only may be paid on the deposit/s, irrespective of the
            higher rate mentioned in the deposits receipts/s.
          </p>
          <p className="status-waiver-content  py-2">
            4) I/We hereby declare and agree that the Bank has got the full
            power and authority to appropriate the schedule mentioned deposit/s
            with interest accrued thereon for the repayment of the outstanding
            balance, including interest/charges etc., on any account whatsoever
            as on date of maturity of deposit or on the date of demand by Bank,
            which ever is earlier, without further notice to me/us.
          </p>
          <p className="status-waiver-content  py-2">
            5) I/WE hereby further undertake that all other incidental expenses,
            costs/charges that may be recoverable from me/us from me/us from
            time to time and interest shall be compounded monthly from the due
            date of payment of deposit/s or date of demand by the Bank,
            whichever is earlier, till payment is received by the Bank in full.
          </p>
          <p className="status-waiver-content  py-2">
            6) I/WE hereby authorize the Bank to credit the Schedule mentioned
            deposit/s with interest accrued thereon to the loan/limit/facility
            account, irrespective of whether the same will create a credit
            balance or not and or to appropriate the proceeds remaining after
            appropriation to the loan account, in adjustment of other
            liabilities which may be owing by me/us to the Bank on any other
            account whatsoever and at any office of the Bank, whether singly or
            jointly with others and whether as principal or as co-obligant or as
            guarantor or as surety.
          </p>
          <p className="status-waiver-content  py-2">
            7) In case of any instruction being issued by me/us to renew the
            deposit/s during the pendency of the loan and in case the Bank at
            its sole and absolute discretion allow to renew the loan facility,
            I/WE hereby agree to Bank holding such renewed deposit receipt/s as
            security in the same way as the original receipt/s with charge as
            aforesaid.
          </p>
          <p className="status-waiver-content  py-2">
            8) I/WE am/are personally liable for any balance that may become due
            to the Bank under the loan/limit/facility account or any account
            whatsoever from time to time.
          </p>
          <p className="status-waiver-content  py-2">
            9) I/WE further declare and agree that in the event of my/our
            requiring the Bank to advance any loan and or to extend financial
            facility/ies at any time hereafter and the Bank granting such loans
            and/or financial facility/ies whether in my/our account or in the
            account of others, it is hereby understood and accepted that such
            facility/ies were extended on the basis of this letter of Lien. Bank
            may apart from my/our personal liability, hold the Schedule
            mentioned deposit receipt/s, outstanding credit balance in the
            deposit account/s including interest accrued thereon as security for
            repayment of all or any amounts that may be outstanding at any time
            and from time to time, until this letter is cancelled by the Bank,
            after I/WE comply with all the requirements as may be required by
            the Bank.
          </p>

          <p className="status-waiver-content py-2">
            10) I/WE hereby declare that the said deposit/s has/have not been
            encumbered or assigned or pledged elsewhere and is free from all
            encumbrances. I/WE hereby expressly agree to Bank computing interest
            on daily debit balance.
          </p>

          <p className="status-waiver-content py-2">
            11) Notwithstanding anything to the contrary contained hereinbefore
            or in any agreement or otherwise, it is specifically agreed that
            Bank shall always be entitiled to have General Lien over/right of
            set off/net off against the schedule mentioned deposit/s, credit
            balance against any of my our liability, whether as borrower or
            co-obligant or guarantor. The Lien hereby created shall not in any
            way affect or prejudice your Lien ie, Banker’s Lien and Bank shall
            always be entitled to exercise the Lien.
          </p>
          <p className="status-waiver-content py-2">
            12) I/WE hereby undertake not to call back the deposit/s until
            my/our liability to the Bank on account of the loan/limit/facility
            allowed in the account of Acetech Heavy Fab Pvt Ltd or any other
            account with interest accrued thereon in which I/WE am/are
            personally liable is/are fully discharged.
          </p>
        </div>
        <h6 className="my-4">A. SCHEDULE OF DEPOSIT ACCOUNTS</h6>
        <table>
          <thead>
            <tr>
              <th className="forward_head_label">S.NO</th>
              <th className="forward_head_label">TYPE OF DEPOSIT</th>
              <th className="forward_head_label">DEPOSIT NO & DATE</th>
              <th className="forward_head_label">VALUE OF DEPOSIT</th>
              <th className="forward_head_label">DATE OF MATURITY</th>
              <th className="forward_head_label">MATURITY VALUE</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="forward_body_label">1</td>
              <td className="forward_body_label">FD</td>
              <td className="forward_body_label">
                {retrievedData?.rolloverType === "sameBg"
                  ? `${retrievedData?.rolloverSameBgM3 || ""} & ${
                      retrievedData?.rolloverSameBgM3Date || ""
                    }`
                  : `${retrievedData?.rolloverNewBgM1 || ""} ${
                      retrievedData?.rolloverNewBgM1Date || ""
                    }`}

                {/* {(retrievedData && retrievedData?.m1AccountNumber) || "-"}&{" "}
                {(retrievedData && retrievedData?.bankDetailsM1Date) || "-"} */}
              </td>
              <td className="forward_body_label">
                {retrievedData?.rolloverType == "sameBg"
                  ? retrievedData?.rolloverSameBgM3Value
                  : retrievedData?.rolloverNewBgM1Value}
              </td>
              <td className="forward_body_label">
                {retrievedData?.rolloverType == "sameBg"
                  ? retrievedData?.rolloverSameBgM3Dom
                  : retrievedData?.rolloverNewBgM1Dom}
              </td>
              <td className="forward_body_label">
                {/* {sessionData && sessionData?.contractAmount} */}

                {retrievedData?.rolloverType == "sameBg"
                  ? retrievedData?.rolloverSameBgM3Mv
                  : retrievedData?.rolloverNewBgM1Mv}
              </td>
            </tr>
            {retrievedData?.rolloverType == "newBg" ? (
              <>
                <tr>
                  <td className="forward_body_label">2</td>
                  <td className="forward_body_label">FD</td>
                  <td className="forward_body_label">
                    {(retrievedData && retrievedData?.rolloverNewBgM2) || "-"}&{" "}
                    {(retrievedData && retrievedData?.rolloverNewBgM2Date) ||
                      "-"}
                  </td>
                  <td className="forward_body_label">
                    {(retrievedData && retrievedData?.rolloverNewBgM2Value) ||
                      "-"}
                  </td>
                  <td className="forward_body_label">
                    {(retrievedData && retrievedData?.rolloverNewBgM2Dom) ||
                      "-"}
                  </td>
                  <td className="forward_body_label">
                    {/* {sessionData && sessionData?.contractAmount} */}

                    {(retrievedData && retrievedData?.rolloverNewBgM2Mv) || "-"}
                  </td>
                </tr>
              </>
            ) : (
              <></>
            )}
          </tbody>
        </table>
        <h6 className="my-4">B. SCHEDULE OF DSD/RD/MD/SB/CD ACCOUNTS </h6>
        <table>
          <thead>
            <tr>
              <th className="forward_head_label">S.NO</th>
              <th className="forward_head_label">TYPE OF DEPOSIT</th>
              <th className="forward_head_label">DEPOSIT NO & DATE</th>
              <th className="forward_head_label">VALUE OF DEPOSIT</th>
              <th className="forward_head_label">DATE OF MATURITY</th>
              <th className="forward_head_label">MATURITY VALUE</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="forward_body_label">{item.sno}</td>
                <td className="forward_body_label"></td>
                <td className="forward_body_label"></td>
                <td className="forward_body_label"></td>
                <td className="forward_body_label"></td>
                <td className="forward_body_label">
                  {/* {sessionData && sessionData?.contractAmount} */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="row my-4">
          <div className="col-12 col-lg-6">
            <p>Place : Chennai</p>
            <p>Date : </p>
          </div>
          <div className="col-12 col-lg-6 d-flex justify-content-center">
            Yours faithfully,
          </div>
        </div>
      </div>
    </>
  );
};

export default LDRollOver;
